import jQuery from 'jquery';
import Flickity from 'flickity';
import Breakpoints from './Breakpoints';
import FixDate from './FixDate';
import 'flickity-fade';

// Register our jquery version with Flickity.
Flickity.setJQuery(jQuery);

const config = {
  mobileSettings: {
    prevNextButtons: false,
    fade: true,
    wrapAround: true,
    pageDots: true,
  },
  tabletSettings: {
    prevNextButtons: false,
    fade: true,
    wrapAround: true,
    pageDots: true,
  },
  desktopSettings: {
    prevNextButtons: false,
    fade: true,
    wrapAround: true,
    pageDots: true,
    autoPlay: 5000,
  },
};

const defaults = {
  date: undefined,
  month: undefined,
  day: undefined,
  year: undefined,
  start: undefined,
  end: undefined,
};

export default class TwitterSlider {
  constructor(element, options) {
    this.element = element;
    this.$element = jQuery(element);
    this.settings = { ...defaults, ...options };
    this.fixDate();

    // Exit if the sliderElement isn't found.
    if (!this.sliderElement) return;

    // Prevent initialization of a slider with less than 2 slides.
    if (this.shouldBuildSlider) {
      // Add listeners
      this.listen();
    }

    // Ready Component
    this.ready();
  }

  ready() {
    this.element.classList.add('ready');
  }

  build(settings) {
    return new Flickity(this.sliderElement, settings);
  }

  restore() {
    return new Promise((resolve) => {
      if (this.slider) {
        this.slider.destroy();
      }
      resolve();
    });
  }

  onMobileChange() {
    this.restore().then(this.slider = this.build(config.mobileSettings));
  }

  onTabletChange() {
    this.restore().then(this.slider = this.build(config.tabletSettings));
  }

  onDesktopChange() {
    this.restore().then(this.slider = this.build(config.desktopSettings));
  }

  listen() {
    // Listen for breakpoint changes
    Breakpoints.on('mobile', 'enter', this.onMobileChange.bind(this));
    Breakpoints.on('tablet', 'enter', this.onTabletChange.bind(this));
    Breakpoints.on('desktop larger', 'enter', this.onDesktopChange.bind(this));
  }

  fixDate() {
    jQuery(this.slides).each((i, elem) => {
      if (elem && !elem.fixDate) {
        elem.fixDate = new FixDate(elem, {
          postDate: false,
        });
      }
    });
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.tweets');
  }

  get slides() {
    return this.sliderElement.children;
  }
}
